module.exports = __webpack_public_path__ + "img/roman.a2b2d5fa.webp";